import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useCart } from '../../context/CartProvider';
import axios from 'axios';
import AddToCartButton from '../common/AddToCartButton';
import './ProductDetail.css';

function ProductDetail() {
    const { category_slug, product_slug } = useParams();
    const { addItem } = useCart();
    const [product, setProduct] = useState(null);
    const [selectedImage, setSelectedImage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    var inStock = "in stock :)"
    var outOfStock = "out of stock :("
    var backToCollection = "< BACK TO COLLECTION"

    const fetchProduct = useCallback(() => {
        setLoading(true);
        axios.get(`/api/v1/products/${product_slug}/`)
            .then(response => {
                const data = response.data;
                const allImages = [];

                // Helper to ensure image has a proper structure
                if (data.get_image) {
                    allImages.push({ image: data.get_image, is_primary: true });
                }
                if (data.images && Array.isArray(data.images)) {
                    data.images.forEach(img => {
                        if (img.image) {
                            allImages.push({
                                image: img.image,
                                is_primary: img.is_primary || false
                            });
                        }
                    });
                }
                setProduct({ ...data, allImages });
            })
            .catch(err => {
                console.error('Error loading product:', err);
                setError(`Failed to load product: ${err.message}`);
            })
            .finally(() => setLoading(false));
    }, [product_slug]);

    useEffect(() => {
        fetchProduct();
    }, [fetchProduct]);

    if (loading) return <div className="loading">Loading...</div>;
    if (error) return <div className="error">{error}</div>;
    if (!product) return <div className="error">Product not found</div>;

    return (
        <div className="product-detail">

            {/* COLUMN 1: Thumbnails */}
            <div className="thumbnails">
                {product.allImages && product.allImages.map((img, index) => (
                    <img
                        key={index}
                        src={img.image}
                        alt={`${product.name} view ${index + 1}`}
                        className={selectedImage === index ? 'active' : ''}
                        onClick={() => setSelectedImage(index)}
                    />
                ))}
            </div>

            {/* COLUMN 2: Main Image */}
            <div className="main-image">
                {product.allImages && product.allImages[selectedImage] && (
                    <img
                        src={product.allImages[selectedImage].image}
                        alt={product.name}
                    />
                )}
            </div>

            {/* COLUMN 3: Product Info & Button */}
            <div className="product-info">
                <h1>{product.name}</h1>
                <div className='price-container'>
                  <button className="price">€{product.price}</button>

                  {/* Stock Status */}
                  <div className="stock-info">
                    {product.stock_quantity > 0 ? (
                      <p className="stock-status in-stock">{product.stock_quantity} {inStock} </p>
                    ) : (
                      <p className="stock-status sold-out">{outOfStock}</p>
                    )}
                  </div>
                </div>

                <p className="description">{product.description}</p>

                <div className="product-meta">
                    {product.size &&
                      <p>
                        <strong>SIZE </strong><span className='meta-value'>{product.size}</span>
                      </p> }
                    {product.material &&
                      <p>
                        <strong>MATERIAL </strong> <span className='meta-value'>{product.material}</span>
                      </p>}
                </div>

                {/* The Add to Cart Button */}
                <div className="action-buttons">
                    <AddToCartButton
                        product={product}
                        addItem={addItem}
                    />
                </div>

                <Link to={`/category/${category_slug}`} className="back-link">
                     {backToCollection}
                </Link>
            </div>
        </div>
    );
}

export default ProductDetail;
